import React from "react";

import "./NewIndicator.css";

export default class NewIndicator extends React.Component {
  
  render() {
    return (
      <div className={`new-indicator ${this.props.className}`}>New!</div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/NewIndicator.js